import { render, staticRenderFns } from "./StockTransportModeFields.vue?vue&type=template&id=75910036"
import script from "./StockTransportModeFields.vue?vue&type=script&lang=js"
export * from "./StockTransportModeFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports